import { Fragment, useState, useEffect, useMemo } from 'react';
import Select from 'react-select';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Modal,
    ModalBody,
    Nav,
    NavItem,
    NavLink,
    Input,
    Spinner,
    Badge,
    FormGroup,
    Label,
} from 'reactstrap';
import CardHeaderSpan from '../../../Utils/CommonComponents/CardHeaderSpan';
import AttendanceMe from '../Attendance/AttendanceMe';
import BorderNav from '../../ProfileTabs/BorderNav';
import BorderTabContent from '../../ProfileTabs/BorderTabContent';
import { ensureDexieReady, getDataFromDexie } from '../../../db/DexieServises';
import FeatherIconCom from '../../../Utils/CommonComponents/CommonIcons/FeatherIconCom';
import { getData, postData } from '../../../CommonElements/Functions/PostGetFun';
import { API } from '../../../api/API';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import Loader from '../../../Layout/Loader';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux-toolkit/store';
import { setSelectedDate as setReduxSelectedDate } from '../../../redux-toolkit/positionSlice';
import { useLabels } from '../../../sharedFunctions/CommonLable';

export default function MeContainer() {
    const getLabel = useLabels();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const reduxSelectedDate = useSelector((state: RootState) => state.position.selectedDate);
    const initialDate = location.state?.date || reduxSelectedDate || localStorage.getItem("selectedDate") || moment().format('YYYY-MM-DD');

    const [employeeId, setEmployeeId] = useState<number | undefined>(undefined);
    const [positionId, setPositionId] = useState<number | undefined>(undefined);
    const [profileTab, setProfileTab] = useState<string>("2");
    const [employeeName, setEmployeeName] = useState<string>('');
    const [selectedDate, setSelectedDateState] = useState<string>(initialDate);

    const updateSelectedDate = (newDate: string) => {
        if (!newDate) {
            setSelectedDateState("");
            dispatch(setReduxSelectedDate(""));
            localStorage.removeItem("selectedDate");
            setDateAttendanceData(null);
            setLoadingDateAttendance(false);
            setInitialLoading(false);
            if (typeof window !== 'undefined' && window.history?.replaceState) {
                window.history.replaceState({}, document.title, window.location.pathname);
            }
            return;
        }
        const formatted = moment(newDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');
        setSelectedDateState(formatted);
        dispatch(setReduxSelectedDate(formatted));
        localStorage.setItem("selectedDate", formatted);
        fetchDateAttendance(formatted);
    };

    useEffect(() => {
        const activeDate = reduxSelectedDate || localStorage.getItem("selectedDate") || location.state?.date;
        if (activeDate && activeDate !== selectedDate) {
            const formatted = moment(activeDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');
            setSelectedDateState(formatted);
            fetchDateAttendance(formatted);
        }
    }, [reduxSelectedDate, location.state?.date]);

    // Real-time clock state
    const [currentTime, setCurrentTime] = useState<Date>(new Date());

    // Attendance Modal & Punch Status API state
    const [attendanceModalOpen, setAttendanceModalOpen] = useState(false);
    const [punchOutModalOpen, setPunchOutModalOpen] = useState(false);

    const [activeTab, setActiveTab] = useState<"working" | "nonWorking">("working");
    const [dayType, setDayType] = useState("R");
    const [punchStatusData, setPunchStatusData] = useState<any>(null);
    const [dateAttendanceData, setDateAttendanceData] = useState<any>(null);

    const [loadingPunchStatus, setLoadingPunchStatus] = useState<boolean>(true);
    const [loadingDateAttendance, setLoadingDateAttendance] = useState<boolean>(Boolean(initialDate));
    const [initialLoading, setInitialLoading] = useState<boolean>(true);
    const [submittingPunchIn, setSubmittingPunchIn] = useState(false);
    const [submittingPunchOut, setSubmittingPunchOut] = useState(false);

    // Expansion & time/town selection state for Mark Attendance Popup
    const [expandedDateIndex, setExpandedDateIndex] = useState<number | null>(null);
    const [selectedTime, setSelectedTime] = useState<string>(() => {
        const now = new Date();
        const h = String(now.getHours()).padStart(2, "0");
        const m = String(now.getMinutes()).padStart(2, "0");
        return `${h}:${m}`;
    });
    const [townsList, setTownsList] = useState<any[]>([]);
    const [loadingTowns, setLoadingTowns] = useState<boolean>(false);
    const [selectedStartTown, setSelectedStartTown] = useState<string>("");
    const [selectedEndTown, setSelectedEndTown] = useState<string>("");

    // Unlock Request State for Locked Dates
    const [unlockRequestsMap, setUnlockRequestsMap] = useState<Record<string, any>>({});
    const [unlockModalOpen, setUnlockModalOpen] = useState<boolean>(false);
    const [selectedLockedItem, setSelectedLockedItem] = useState<any>(null);
    const [unlockRemark, setUnlockRemark] = useState<string>('');
    const [unlockLoading, setUnlockLoading] = useState<boolean>(false);
    const [loadingAttendanceDetail, setLoadingAttendanceDetail] = useState<boolean>(false);

    const handleOpenUnlockModal = async (item: any) => {
        const serverUrl = localStorage.getItem("serverUrl");
        const rawD = item.date || item.AttendanceDate;
        const targetD = moment(rawD, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');
        setSelectedLockedItem(item);
        setUnlockRemark('');
        setUnlockModalOpen(true);

        const currentStatus = unlockRequestsMap[targetD]?.status || item?.AttendanceRequestStatus || item?.RequestStatus;
        if (currentStatus === 'Requested' || currentStatus === 'Rejected') {
            if (!serverUrl) return;
            setLoadingAttendanceDetail(true);
            try {
                const url = `${serverUrl}${API.getAttendanceByDate}`;
                const res = await getData(url, true, { attendance_date: targetD });
                if ((res.status === 200 || res.data?.statusCode === 200) && Array.isArray(res.data?.data) && res.data.data.length > 0) {
                    const att = res.data.data[0];
                    setUnlockRequestsMap(prev => ({
                        ...prev,
                        [targetD]: {
                            status: att.RequestStatus,
                            sentAt: att.UpdatedAt || att.CreatedAt,
                            remark: att.RequestRemark
                        }
                    }));
                }
            } catch (e) {
                console.error("Failed to load attendance request details", e);
            } finally {
                setLoadingAttendanceDetail(false);
            }
        }
    };

    const handleSendUnlockRequest = async () => {
        const serverUrl = localStorage.getItem("serverUrl");
        if (!selectedLockedItem || !serverUrl) return;
        if (!unlockRemark.trim()) {
            toast.error("Please enter a remark before sending the request.");
            return;
        }
        const rawD = selectedLockedItem.date || selectedLockedItem.AttendanceDate;
        const targetD = moment(rawD, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');

        setUnlockLoading(true);
        try {
            const url = `${serverUrl}${API.createAttendanceLockReq}`;
            const payload = {
                request_date: targetD,
                request_remark: unlockRemark.trim(),
            };
            const response = await postData(url, true, payload);
            const ok = response.status === 200 || response.data?.statusCode === 200;

            if (ok) {
                toast.success(response.data?.message || "Attendance lock request sent successfully.");
                setUnlockRequestsMap(prev => ({
                    ...prev,
                    [targetD]: {
                        status: 'Requested',
                        sentAt: new Date(),
                        remark: unlockRemark.trim()
                    }
                }));
                setUnlockModalOpen(false);
                setUnlockRemark('');
                setSelectedLockedItem(null);
                fetchPunchStatus(dayType);
            } else {
                toast.error(response.data?.message || "Failed to send request.");
            }
        } catch (e: any) {
            console.error("Error sending unlock request:", e);
            toast.error(e?.message || "An error occurred while sending the request.");
        } finally {
            setUnlockLoading(false);
        }
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                await ensureDexieReady();
                const rawData = await getDataFromDexie('Employee');
                if (rawData && rawData.length > 0) {
                    setEmployeeId(rawData[0]?.EmployeeId);
                    setPositionId(rawData[0]?.PositionId);
                    const name = rawData[0]?.EmployeeName || rawData[0]?.FirstName || rawData[0]?.Name || rawData[0]?.EmpName || '';
                    setEmployeeName(name);
                }
            } catch (err) {
                console.error("Failed to load employee data for ME tab:", err);
            }
        };
        fetchUserData();
    }, []);

    const fetchPunchStatus = async (currentDayType: string) => {
        const serverUrl = localStorage.getItem("serverUrl");
        if (!serverUrl) {
            setLoadingPunchStatus(false);
            return;
        }
        setLoadingPunchStatus(true);
        try {
            const url = `${serverUrl}${API.punchStatus}`;
            const response = await getData(url, true, { day_type: currentDayType });
            if (response.status === 200) {
                setPunchStatusData(response.data);
            } else {
                setPunchStatusData(null);
            }
        } catch (error) {
            console.error("Error fetching punch status:", error);
            setPunchStatusData(null);
        } finally {
            setLoadingPunchStatus(false);
        }
    };

    const fetchDateAttendance = async (targetDate: string) => {
        const serverUrl = localStorage.getItem("serverUrl");
        if (!serverUrl || !targetDate) {
            setLoadingDateAttendance(false);
            setInitialLoading(false);
            return;
        }
        setLoadingDateAttendance(true);
        try {
            const formattedDateParam = moment(targetDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('DD-MM-YYYY');
            const url = `${serverUrl}${API.punchStatusByDate}`;
            const response = await getData(url, true, { date: formattedDateParam });
            console.log("punchStatusByDate API response:", response);
            if (response.status === 200 || response.data?.statusCode === 200) {
                const dataObj = response.data?.data || response.data;
                setDateAttendanceData(dataObj);

                const returnedDate = dataObj?.date || dataObj?.AttendanceDate;
                if (returnedDate) {
                    const cleanDate = moment(returnedDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD');
                    setSelectedDateState(cleanDate);
                    dispatch(setReduxSelectedDate(cleanDate));
                    localStorage.setItem("selectedDate", cleanDate);
                }
            } else {
                setDateAttendanceData(null);
            }
        } catch (error) {
            console.error("Error fetching date attendance:", error);
            setDateAttendanceData(null);
        } finally {
            setLoadingDateAttendance(false);
            setInitialLoading(false);
        }
    };

    useEffect(() => {
        fetchPunchStatus(dayType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (selectedDate) {
            fetchDateAttendance(selectedDate);
        } else {
            setLoadingDateAttendance(false);
            setInitialLoading(false);
        }
    }, [selectedDate]);

    const handleTabPress = (tab: "working" | "nonWorking") => {
        setActiveTab(tab);
        setExpandedDateIndex(null);
        let newDayType = "R";
        if (tab === "working") {
            newDayType = "R";
        } else if (tab === "nonWorking") {
            newDayType = "W,H";
        }
        setDayType(newDayType);
        fetchPunchStatus(newDayType);
    };

    const fetchTowns = async () => {
        const serverUrl = localStorage.getItem("serverUrl");
        if (!serverUrl) return;
        setLoadingTowns(true);
        try {
            const url = `${serverUrl}${API.towns}`;
            const response = await getData(url, true);
            let list: any[] = [];
            const d = response?.data;
            if (Array.isArray(d)) {
                list = d;
            } else if (Array.isArray(d?.data)) {
                list = d.data;
            } else if (Array.isArray(d?.towns)) {
                list = d.towns;
            } else if (Array.isArray(d?.Towns)) {
                list = d.Towns;
            } else if (Array.isArray(d?.territories)) {
                list = d.territories;
            } else if (Array.isArray(d?.items)) {
                list = d.items;
            } else if (Array.isArray(d?.result)) {
                list = d.result;
            } else if (d?.data && typeof d.data === 'object') {
                if (Array.isArray(d.data.towns)) list = d.data.towns;
                else if (Array.isArray(d.data.Towns)) list = d.data.Towns;
                else if (Array.isArray(d.data.territories)) list = d.data.territories;
            }

            setTownsList(list);
            if (list.length > 0) {
                const first = list[0];
                const firstId = typeof first === 'object' && first !== null
                    ? (first.Itownid ?? first.itownid ?? first.town_id ?? first.TownId ?? first.id ?? first.Stownname ?? first.town_name ?? first.name ?? "")
                    : first;
                setSelectedStartTown((prev) => prev || String(firstId));
                setSelectedEndTown((prev) => prev || String(firstId));
            }
        } catch (error) {
            console.error("Error fetching towns:", error);
        } finally {
            setLoadingTowns(false);
        }
    };

    useEffect(() => {
        fetchTowns();
    }, []);

    const townOptions = useMemo(() => {
        if (!Array.isArray(townsList)) return [];
        return townsList.map((town: any, index: number) => {
            const townId = typeof town === 'object' && town !== null
                ? (town.Itownid ?? town.itownid ?? town.town_id ?? town.TownId ?? town.id ?? town.Stownname ?? town.town_name ?? town.name ?? index)
                : town;
            const townName = typeof town === 'object' && town !== null
                ? (town.Stownname ?? town.town_name ?? town.TownName ?? town.name ?? town.Town ?? town.label ?? townId)
                : town;
            return {
                value: String(townId),
                label: String(townName),
            };
        });
    }, [townsList]);

    const getTownNameById = (townId: string) => {
        if (!townId) return "";
        const found = townOptions.find((opt) => String(opt.value) === String(townId));
        return found ? found.label : townId;
    };

    const townSelectStyles = {
        control: (base: any, state: any) => ({
            ...base,
            minHeight: '38px',
            borderRadius: '4px',
            borderColor: state.isFocused ? '#2684ff' : '#dee2e6',
            boxShadow: 'none',
            fontSize: '0.9rem',
            fontWeight: '600',
            backgroundColor: '#ffffff',
            cursor: 'pointer',
        }),
        singleValue: (base: any) => ({
            ...base,
            color: '#000000',
            fontWeight: '600',
        }),
        placeholder: (base: any) => ({
            ...base,
            color: '#6c757d',
            fontWeight: 'normal',
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 9999,
        }),
        menu: (base: any) => ({
            ...base,
            zIndex: 9999,
        }),
        option: (base: any, state: any) => ({
            ...base,
            fontSize: '0.88rem',
            color: '#000000',
            backgroundColor: state.isSelected
                ? '#e9ecef'
                : state.isFocused
                ? '#f8f9fa'
                : '#ffffff',
            cursor: 'pointer',
        }),
    };

    const toggleAttendanceModal = () => {
        const nextState = !attendanceModalOpen;
        setAttendanceModalOpen(nextState);
        if (nextState) {
            setExpandedDateIndex(null);
            fetchPunchStatus(dayType);
            fetchTowns();
        }
    };

    const getCoordinates = (): Promise<string> => {
        return new Promise((resolve) => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve(`${position.coords.latitude},${position.coords.longitude}`);
                    },
                    () => resolve("not found"),
                    { timeout: 3000 }
                );
            } else {
                resolve("not found");
            }
        });
    };

    const handlePunchIn = async (itemDate: string) => {
        const serverUrl = localStorage.getItem("serverUrl");
        if (!serverUrl) return;

        if (!selectedStartTown) {
            toast.error("Please select a start town");
            return;
        }

        setSubmittingPunchIn(true);
        try {
            const url = `${serverUrl}${API.punchin}`;
            const latlntStr = await getCoordinates();
            const formattedTime = selectedTime ? moment(selectedTime, ['HH:mm', 'hh:mm A']).format('HH:mm') : '';

            const params = {
                punchin_date: itemDate,
                punchin_time: formattedTime,
                latlnt: latlntStr,
                location: 'not found',
                start_itownid: selectedStartTown,
            };

            const response = await postData(url, true, params);

            if (response.status === 200 || response.data?.statusCode === 200) {
                toast.success(response.data?.message || "Punch in successful!");
                const targetD = response.data?.data?.date || response.data?.date || itemDate;
                updateSelectedDate(targetD);
                setExpandedDateIndex(null);
                fetchPunchStatus(dayType);
                toggleAttendanceModal();
            } else {
                toast.error(response.data?.message || response.data?.error || "Failed to punch in");
            }
        } catch (error: any) {
            console.error("Punch in error:", error);
            toast.error(error?.message || "An error occurred while punching in");
        } finally {
            setSubmittingPunchIn(false);
        }
    };

    const handlePunchOut = async (itemDate: string) => {
        const serverUrl = localStorage.getItem("serverUrl");
        if (!serverUrl) return;

        if (!selectedEndTown) {
            toast.error("Please select an end town");
            return;
        }

        setSubmittingPunchOut(true);
        try {
            const url = `${serverUrl}${API.punchout}`;
            const latlntStr = await getCoordinates();
            const formattedTime = selectedTime ? moment(selectedTime, ['HH:mm', 'hh:mm A']).format('HH:mm') : '';

            const params = {
                punchout_date: itemDate,
                punchout_time: formattedTime,
                latlnt: latlntStr,
                location: 'not found',
                end_itownid: selectedEndTown,
                remark: '',
            };

            const response = await postData(url, true, params);

            if (response.status === 200 || response.data?.statusCode === 200) {
                toast.success(response.data?.message || "Punch out successful!");
                // Clear date data on punch out
                updateSelectedDate("");
                setDateAttendanceData(null);
                setExpandedDateIndex(null);
                fetchPunchStatus(dayType);
                setPunchOutModalOpen(false);
            } else {
                toast.error(response.data?.message || response.data?.error || "Failed to punch out");
            }
        } catch (error: any) {
            console.error("Punch out error:", error);
            toast.error(error?.message || "An error occurred while punching out");
        } finally {
            setSubmittingPunchOut(false);
        }
    };

    // Helper to format date strings like "Thursday, 10th Sep 2026"
    const formatDayDate = (dateStr: string) => {
        if (!dateStr) return "";
        try {
            const d = new Date(dateStr);
            if (isNaN(d.getTime())) return dateStr;
            const weekday = d.toLocaleDateString("en-US", { weekday: "long" });
            const day = d.getDate();
            const month = d.toLocaleDateString("en-US", { month: "short" });
            const year = d.getFullYear();

            const getOrdinal = (n: number) => {
                const s = ["th", "st", "nd", "rd"];
                const v = n % 100;
                return n + (s[(v - 20) % 10] || s[v] || s[0]);
            };

            return `${weekday}, ${getOrdinal(day)} ${month} ${year}`;
        } catch (e) {
            return dateStr;
        }
    };

    // Helper to format time "17:57" or "2026-10-23 21:00:00" into 12h format "05:57 PM"
    const formatTime12h = (time24: any) => {
        if (!time24) return "";
        const timeStr = typeof time24 === 'object' && time24 !== null && time24.date ? time24.date : String(time24);
        const parts = timeStr.trim().split(" ");
        const timePart = parts.length > 1 ? parts[1] : parts[0];
        const [h, m] = timePart.split(":");
        let hours = parseInt(h, 10);
        if (isNaN(hours)) return timeStr;
        const minutes = m || "00";
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
        return `${hoursStr}:${minutes} ${ampm}`;
    };

    const calculateWorkingDuration = (pInTime: any, pOutTime?: any) => {
        if (!pInTime) return "";
        const pInStr = typeof pInTime === 'object' && pInTime !== null && pInTime.date ? pInTime.date : String(pInTime);
        const pOutStr = typeof pOutTime === 'object' && pOutTime !== null && pOutTime.date ? pOutTime.date : (pOutTime ? String(pOutTime) : null);
        const startMom = moment(pInStr, ['YYYY-MM-DD HH:mm:ss', 'HH:mm:ss', 'HH:mm', 'YYYY-MM-DD HH:mm']);
        if (!startMom.isValid()) return "";
        const endMom = pOutStr && moment(pOutStr, ['YYYY-MM-DD HH:mm:ss', 'HH:mm:ss', 'HH:mm', 'YYYY-MM-DD HH:mm']).isValid()
            ? moment(pOutStr, ['YYYY-MM-DD HH:mm:ss', 'HH:mm:ss', 'HH:mm', 'YYYY-MM-DD HH:mm'])
            : moment(currentTime);

        const diffMs = Math.max(0, endMom.diff(startMom));
        const dur = moment.duration(diffMs);
        const hours = Math.floor(dur.asHours());
        const minutes = dur.minutes();

        const hStr = String(hours).padStart(2, '0');
        const mStr = String(minutes).padStart(2, '0');

        return `${hStr}H:${mStr}M`;
    };

    // Safely parse data items array from API response in descending chronological order
    const getItemList = (): any[] => {
        let list: any[] = [];
        if (!punchStatusData) list = [];
        else if (Array.isArray(punchStatusData)) list = punchStatusData;
        else if (Array.isArray(punchStatusData?.data)) list = punchStatusData.data;
        else if (Array.isArray(punchStatusData?.status)) list = punchStatusData.status;

        return [...list].sort((a: any, b: any) => {
            const rawA = a?.date || a?.AttendanceDate || '';
            const rawB = b?.date || b?.AttendanceDate || '';

            const momA = moment(rawA, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss', moment.ISO_8601]);
            const momB = moment(rawB, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss', moment.ISO_8601]);

            const timeA = momA.isValid() ? momA.valueOf() : moment(rawA).valueOf();
            const timeB = momB.isValid() ? momB.valueOf() : moment(rawB).valueOf();

            if (isNaN(timeA) && isNaN(timeB)) return 0;
            if (isNaN(timeA)) return 1;
            if (isNaN(timeB)) return -1;

            return timeB - timeA; // Descending: latest/current dates first, followed by older/past dates
        });
    };

    const attendanceDayList = getItemList();

    const getActivePunchItem = () => {
        if (!attendanceDayList || attendanceDayList.length === 0) return null;
        const target = selectedDate || moment().format('YYYY-MM-DD');
        const targetClean = moment(target, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD');
        const found = attendanceDayList.find((item: any) => {
            const d = item.date || item.AttendanceDate;
            return moment(d, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD') === targetClean;
        });
        return found || null;
    };

    const activePunchItem = getActivePunchItem();

    // Priority: dateAttendanceData (from /api/attendance/date?date=...) has the highest precedence for selectedDate,
    // fallback to activePunchItem (from /api/attendance/status?day_type=...).
    const currentPunchStatus = dateAttendanceData?.punchStatus !== undefined && dateAttendanceData?.punchStatus !== null
        ? Number(dateAttendanceData.punchStatus)
        : (activePunchItem?.punchStatus !== undefined && activePunchItem?.punchStatus !== null ? Number(activePunchItem.punchStatus) : undefined);

    const currentNote = String(dateAttendanceData?.Note || activePunchItem?.Note || '').toLowerCase();

    // punchStatus === 0 or 1 means Punched In ("Punched in - Out is pending")
    const isPunchedInActive = Boolean(
        currentPunchStatus === 0 ||
        currentPunchStatus === 1 ||
        (currentPunchStatus === undefined && (currentNote.includes('punched in') || currentNote.includes('out is pending')))
    );

    // punchStatus === 2 means Punched Out ("Punched Out")
    const isPunchedOut = !isPunchedInActive && Boolean(
        currentPunchStatus === 2 ||
        currentNote.includes('punched out')
    );

    // punchStatus === -2 means Not Started ("No Attendance")
    const isNotStarted = !isPunchedInActive && !isPunchedOut && Boolean(
        currentPunchStatus === -2 ||
        currentNote.includes('no attendance') ||
        currentPunchStatus === undefined
    );

    const activePunchinTimeRaw = dateAttendanceData?.punchinTime || activePunchItem?.punchinTime || activePunchItem?.punchin_time || activePunchItem?.PunchinTime || activePunchItem?.Starttime || '';
    const formattedPunchinTime12 = activePunchinTimeRaw ? formatTime12h(activePunchinTimeRaw) : '';
    const workingDurationStr = activePunchinTimeRaw ? calculateWorkingDuration(activePunchinTimeRaw, dateAttendanceData?.punchoutTime) : '';

    const isAttendanceCardLoading = loadingDateAttendance || (initialLoading && loadingPunchStatus);

    return (
        <Fragment>
            <Container fluid className="p-3">
                <Card>
                    {/* 1. "ME" Heading at the VERY TOP of the page */}
                    <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                        <CardHeaderSpan headingClassName="pb-0" back={false} heading={getLabel("Me") || "ME"} span="Personal Dashboard & Performance" />
                    </div>

                    <CardBody>
                        {/* 2. Wide Attendance Banner Card with exact content and illustration graphic */}
                        <div className="mb-4">
                            {isAttendanceCardLoading ? (
                                <Card
                                    className="border-0 shadow-sm overflow-hidden"
                                    style={{
                                        borderRadius: '16px',
                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
                                        border: 'none',
                                        minHeight: '210px',
                                        backgroundColor: '#ffffff',
                                    }}
                                >
                                    <CardBody className="p-4 d-flex align-items-center justify-content-center" style={{ minHeight: '210px' }}>
                                        <Loader height="160px" />
                                    </CardBody>
                                </Card>
                            ) : (
                                <Card
                                    className="border-0 shadow-sm overflow-hidden"
                                    style={{
                                        borderRadius: '16px',
                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
                                        background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 40%), linear-gradient(125deg, #2d7df8 0%, #3582f6 50%, #458dee 100%)',
                                        border: 'none',
                                    }}
                                >
                                    <CardBody className="p-4 p-md-4 bg-transparent">
                                        <Row className="align-items-center g-4">
                                        {/* Left Side: All Attendance Card Content & Buttons */}
                                        <Col md={8} lg={9}>
                                            <div className="d-flex flex-column align-items-start text-start">
                                                {isPunchedInActive ? (
                                                    <>
                                                        {/* Selected Date Header (only if viewing a date different from current date) */}
                                                        {selectedDate && moment(selectedDate).format('YYYY-MM-DD') !== moment(currentTime).format('YYYY-MM-DD') && (
                                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                                <span className="small fw-bold text-uppercase tracking-wide" style={{ fontSize: '0.75rem', letterSpacing: '1px', color: '#ffffff' }}>
                                                                    SELECTED DATE
                                                                </span>
                                                                <Badge color="primary" className="px-2 py-1 fw-bold" style={{ fontSize: '0.78rem' }}>
                                                                    {moment(selectedDate).format('YYYY-MM-DD')}
                                                                </Badge>
                                                            </div>
                                                        )}

                                                        {/* Date Title */}
                                                        <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#ffffff', letterSpacing: '-0.5px' }}>
                                                            {selectedDate ? moment(selectedDate).format('dddd, DD MMMM YYYY') : moment(currentTime).format('dddd, DD MMMM YYYY')}
                                                        </div>

                                                        {/* Live Clock Time */}
                                                        <div className="fw-semibold mb-2 d-flex align-items-center" style={{ fontSize: '0.88rem', color: '#ffffff' }}>
                                                            <FeatherIconCom iconName="Clock" size={13} className="me-1" style={{ stroke: '#ffffff', color: '#ffffff' }} />
                                                            <span>Current Time: {currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}</span>
                                                        </div>

                                                        {/* Working Duration Pill */}
                                                        {activePunchinTimeRaw && (
                                                            <div className="text-primary fw-bold mb-2 px-3 py-1.5 rounded-3" style={{ backgroundColor: '#f0f7ff', color: '#0d6efd', fontSize: '0.88rem' }}>
                                                                Working from {formattedPunchinTime12} - {workingDurationStr}
                                                            </div>
                                                        )}

                                                        {/* User Greeting */}
                                                        {employeeName && (
                                                            <div className="fw-bold mb-1" style={{ fontSize: '1.05rem', color: '#ffffff' }}>
                                                                Have a nice day, {employeeName}!
                                                            </div>
                                                        )}

                                                        {/* Active Status Indicator */}
                                                        <div className="fw-bold small mb-3 d-flex align-items-center gap-1" style={{ fontSize: '0.88rem', color: '#86efac' }}>
                                                            <FeatherIconCom iconName="CheckCircle" size={14} style={{ stroke: '#86efac', color: '#86efac' }} />
                                                            <span>{dateAttendanceData?.Note || (formattedPunchinTime12 ? `Punched in at ${formattedPunchinTime12}` : "Day Started")}</span>
                                                        </div>

                                                        {/* Action Buttons matching reference image */}
                                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                                            <Button
                                                                color="danger"
                                                                className="px-3 py-2 d-flex align-items-center gap-1 text-white border-0 shadow-sm"
                                                                style={{ backgroundColor: '#dc3545', borderRadius: '8px', fontSize: '0.85rem', fontWeight: '600' }}
                                                                onClick={() => {
                                                                    fetchTowns();
                                                                    setPunchOutModalOpen(true);
                                                                }}
                                                            >
                                                                <FeatherIconCom iconName="LogOut" size={15} />
                                                                <span>{getLabel("EndMyDay") || "End my day"}</span>
                                                            </Button>

                                                            <Button
                                                                color="light"
                                                                className="px-3 py-2 d-flex align-items-center gap-1 fw-semibold border-0 me-banner-btn"
                                                                style={{
                                                                    backgroundColor: '#ffffff',
                                                                    color: '#0d6efd',
                                                                    borderRadius: '8px',
                                                                    fontSize: '0.85rem',
                                                                    fontWeight: '600',
                                                                }}
                                                                onClick={toggleAttendanceModal}
                                                            >
                                                                <FeatherIconCom iconName="Calendar" size={15} />
                                                                <span>Change Day</span>
                                                            </Button>

                                                            <Button
                                                                color="light"
                                                                className="px-3 py-2 d-flex align-items-center gap-1 fw-semibold border-0 me-banner-btn"
                                                                style={{
                                                                    backgroundColor: '#ffffff',
                                                                    color: '#0d6efd',
                                                                    borderRadius: '8px',
                                                                    fontSize: '0.85rem',
                                                                    fontWeight: '600',
                                                                }}
                                                                onClick={() => {
                                                                    updateSelectedDate(selectedDate);
                                                                    navigate('/me/agenda', { state: { date: selectedDate } });
                                                                }}
                                                            >
                                                                <FeatherIconCom iconName="Calendar" size={15} />
                                                                <span>{moment(selectedDate || currentTime).format('D MMM')}'s Agenda</span>
                                                            </Button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {/* Post-Punch-Out / Day Not Started State */}
                                                        {/* Selected Date Header (only if viewing a date different from current date) */}
                                                        {selectedDate && moment(selectedDate).format('YYYY-MM-DD') !== moment(currentTime).format('YYYY-MM-DD') && (
                                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                                <span className="small fw-bold text-uppercase tracking-wide" style={{ fontSize: '0.75rem', letterSpacing: '1px', color: '#ffffff' }}>
                                                                    SELECTED DATE
                                                                </span>
                                                                <Badge color="primary" className="px-2 py-1 fw-bold" style={{ fontSize: '0.78rem' }}>
                                                                    {moment(selectedDate).format('YYYY-MM-DD')}
                                                                </Badge>
                                                            </div>
                                                        )}

                                                        {/* Current / Selected Date Display */}
                                                        <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#ffffff', letterSpacing: '-0.5px' }}>
                                                            {selectedDate ? moment(selectedDate).format('dddd, DD MMMM YYYY') : moment(currentTime).format('dddd, DD MMMM YYYY')}
                                                        </div>

                                                        {/* Live Clock Time */}
                                                        <div className="fw-semibold mb-2 d-flex align-items-center" style={{ fontSize: '0.88rem', color: '#ffffff' }}>
                                                            <FeatherIconCom iconName="Clock" size={13} className="me-1" style={{ stroke: '#ffffff', color: '#ffffff' }} />
                                                            <span>Current Time: {currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}</span>
                                                        </div>

                                                        {/* User Greeting */}
                                                        {employeeName && (
                                                            <div className="fw-bold mb-2" style={{ fontSize: '1.05rem', color: '#ffffff' }}>
                                                                Have a nice day, {employeeName}!
                                                            </div>
                                                        )}

                                                        {/* Status Indicator for Punched Out / Not Started */}
                                                        <div className="fw-bold small mb-3 d-flex align-items-center gap-1" style={{ fontSize: '0.88rem', color: isPunchedOut ? '#fef08a' : '#bfdbfe' }}>
                                                            <FeatherIconCom iconName={isPunchedOut ? "CheckCircle" : "AlertCircle"} size={14} />
                                                            <span>{dateAttendanceData?.Note || activePunchItem?.Note || (isPunchedOut ? "Punched Out" : "Day Not Started")}</span>
                                                        </div>

                                                        {/* Action Buttons */}
                                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                                            {!isPunchedOut && (
                                                                <Button
                                                                    color="light"
                                                                    className="px-4 py-2 d-flex align-items-center gap-2 border-0 fw-bold me-banner-btn"
                                                                    style={{
                                                                        backgroundColor: '#ffffff',
                                                                        color: '#0d6efd',
                                                                        borderRadius: '8px',
                                                                        fontWeight: '700',
                                                                    }}
                                                                    onClick={toggleAttendanceModal}
                                                                >
                                                                    <FeatherIconCom iconName="UserCheck" size={16} />
                                                                    <span>Lets Start Day</span>
                                                                </Button>
                                                            )}

                                                            <Button
                                                                color="light"
                                                                className="px-3 py-2 d-flex align-items-center gap-1 fw-semibold border-0 me-banner-btn"
                                                                style={{
                                                                    backgroundColor: '#ffffff',
                                                                    color: '#0d6efd',
                                                                    borderRadius: '8px',
                                                                    fontSize: '0.85rem',
                                                                    fontWeight: '600',
                                                                }}
                                                                onClick={toggleAttendanceModal}
                                                            >
                                                                <FeatherIconCom iconName="Calendar" size={15} />
                                                                <span>Change Day</span>
                                                            </Button>

                                                            <Button
                                                                color="light"
                                                                className="px-3 py-2 d-flex align-items-center gap-1 fw-semibold border-0 me-banner-btn"
                                                                style={{
                                                                    backgroundColor: '#ffffff',
                                                                    color: '#0d6efd',
                                                                    borderRadius: '8px',
                                                                    fontSize: '0.85rem',
                                                                    fontWeight: '600',
                                                                }}
                                                                onClick={() => {
                                                                    updateSelectedDate(selectedDate);
                                                                    navigate('/me/agenda', { state: { date: selectedDate } });
                                                                }}
                                                            >
                                                                <FeatherIconCom iconName="Calendar" size={15} />
                                                                <span>{moment(selectedDate || currentTime).format('D MMM')}'s Agenda</span>
                                                            </Button>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </Col>

                                        {/* Right Side: Welcome Illustration Image */}
                                        <Col md={4} lg={3} className="text-center text-md-end d-none d-md-block">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/assets/images/dashboard/welcome.png`}
                                                alt="Welcome Illustration"
                                                style={{
                                                    maxHeight: '170px',
                                                    maxWidth: '100%',
                                                    objectFit: 'contain',
                                                }}
                                                onError={(e: any) => {
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            )}
                        </div>

                        {/* 3. User Profile Tabs Component directly under Attendance Card (without User Profile Header) */}
                        <div className="mt-3">
                            <BorderNav basicTab={profileTab} setBasicTab={setProfileTab} employeeIdProp={employeeId || 1} />
                            <BorderTabContent tabId={profileTab} employeeIdProp={employeeId} tdate={selectedDate} positionId={positionId} />
                        </div>
                    </CardBody>
                </Card>
            </Container>

            {/* Compact Mark Attendance Date List Popup */}
            <Modal
                isOpen={attendanceModalOpen}
                toggle={toggleAttendanceModal}
                centered
                style={{ maxWidth: '440px' }}
                contentClassName="border-0 shadow-lg"
            >
                <div
                    className="modal-header d-flex justify-content-between align-items-center border-0 pb-0 pt-4 px-4"
                    style={{ borderRadius: '20px 20px 0 0' }}
                >
                    <h5 className="modal-title fw-bold text-dark" style={{ fontSize: '1.2rem' }}>
                        Mark Attendance: Select a Day
                    </h5>
                    <button
                        type="button"
                        className="btn-close-custom d-flex align-items-center justify-content-center border-0 text-white"
                        onClick={toggleAttendanceModal}
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            backgroundColor: '#495057',
                            cursor: 'pointer',
                        }}
                    >
                        <FeatherIconCom iconName="X" size={18} className="text-white" />
                    </button>
                </div>

                <ModalBody className="px-4 pt-2 pb-4">
                    {/* Working / Non-Working Tabs */}
                    <Nav className="nav-tabs border-bottom mb-3" style={{ borderBottomWidth: '2px' }}>
                        <NavItem className="w-50 text-center">
                            <NavLink
                                className={`fw-semibold py-2 px-0 border-0 ${activeTab === "working" ? "active border-bottom border-primary text-primary" : "text-muted"}`}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "1rem",
                                    borderBottom: activeTab === "working" ? "2px solid #0d6efd" : "none",
                                    background: "transparent",
                                }}
                                onClick={() => handleTabPress("working")}
                            >
                                Working
                            </NavLink>
                        </NavItem>
                        <NavItem className="w-50 text-center">
                            <NavLink
                                className={`fw-semibold py-2 px-0 border-0 ${activeTab === "nonWorking" ? "active border-bottom border-primary text-primary" : "text-muted"}`}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "1rem",
                                    borderBottom: activeTab === "nonWorking" ? "2px solid #0d6efd" : "none",
                                    background: "transparent",
                                }}
                                onClick={() => handleTabPress("nonWorking")}
                            >
                                Non-Working
                            </NavLink>
                        </NavItem>
                    </Nav>

                    {/* Scrollable Day List */}
                    {loadingPunchStatus ? (
                        <Loader height="200px" />
                    ) : (
                        <div
                            style={{
                                maxHeight: '420px',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                paddingRight: '4px',
                            }}
                        >
                            {attendanceDayList.length > 0 ? (
                                attendanceDayList.map((item: any, idx: number) => {
                                    const formattedDate = formatDayDate(item.date || item.AttendanceDate);
                                    const isPunchedIn = item.punchStatus === 0 || item.punchStatus === 1;
                                    const isPunchedOut = item.punchStatus === 2;
                                    const isNotStarted = item.punchStatus === -2;
                                    const isLocked = item.punchStatus === -1;

                                    const noteStatus = item.Note || (isNotStarted ? "No Attendance" : isPunchedIn ? "Punched in - Out is pending" : isPunchedOut ? "Punched Out" : "No Attendance");
                                    const isExpanded = expandedDateIndex === idx;

                                    return (
                                        <div
                                            key={idx}
                                            className="py-3 border-bottom"
                                            style={{ borderColor: '#f1f1f1' }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div style={{ flex: 1, paddingRight: '12px', minWidth: 0 }}>
                                                    <div
                                                        className="fw-bold text-dark text-truncate"
                                                        style={{ fontSize: '0.95rem', marginBottom: '2px' }}
                                                    >
                                                        {formattedDate}
                                                    </div>
                                                    <div
                                                        className="text-muted text-truncate"
                                                        style={{ fontSize: '0.825rem' }}
                                                    >
                                                        {noteStatus}
                                                    </div>
                                                </div>
                                                <div>
                                                    {isLocked ? (() => {
                                                        const rawItemDate = item.date || item.AttendanceDate;
                                                        const itemDateClean = moment(rawItemDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');
                                                        const reqStatus = unlockRequestsMap[itemDateClean]?.status || item?.AttendanceRequestStatus || item?.RequestStatus;

                                                        return (
                                                            <div className="d-flex align-items-center gap-1">
                                                                <span className="badge bg-danger">Locked</span>
                                                                <Button
                                                                    size="sm"
                                                                    color={
                                                                        reqStatus === 'Requested' ? 'warning' :
                                                                        reqStatus === 'Rejected' ? 'danger' :
                                                                        'primary'
                                                                    }
                                                                    outline={reqStatus === 'Requested' || reqStatus === 'Rejected'}
                                                                    className="px-2 py-1"
                                                                    style={{ borderRadius: '6px', fontSize: '0.8rem' }}
                                                                    onClick={() => handleOpenUnlockModal(item)}
                                                                >
                                                                    {reqStatus === 'Requested' ? 'Requested' :
                                                                     reqStatus === 'Rejected' ? 'Rejected' :
                                                                     'Request Unlock'}
                                                                </Button>
                                                            </div>
                                                        );
                                                    })() : isPunchedOut ? (
                                                        <Button
                                                            color="secondary"
                                                            outline
                                                            size="sm"
                                                            className="px-3 py-1"
                                                            style={{ borderRadius: '6px', fontSize: '0.85rem' }}
                                                            onClick={() => {
                                                                const rawD = item.date || item.AttendanceDate;
                                                                const targetD = moment(rawD, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');
                                                                updateSelectedDate(targetD);
                                                                toast.success(`Selected date: ${moment(targetD).format('DD MMM YYYY')}`);
                                                                setAttendanceModalOpen(false);
                                                            }}
                                                        >
                                                            Select Date
                                                        </Button>
                                                    ) : isPunchedIn ? (
                                                        /* Direct select date if already punched in */
                                                        <Button
                                                            color="success"
                                                            size="sm"
                                                            className="px-3 py-1 border-0 text-white"
                                                            style={{ borderRadius: '6px', fontSize: '0.85rem' }}
                                                            onClick={() => {
                                                                const rawD = item.date || item.AttendanceDate;
                                                                const targetD = moment(rawD, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');
                                                                updateSelectedDate(targetD);
                                                                toast.success(`Selected date: ${moment(targetD).format('DD MMM YYYY')}`);
                                                                setAttendanceModalOpen(false);
                                                            }}
                                                        >
                                                            Select Date
                                                        </Button>
                                                    ) : (
                                                        /* Punch In Expandable for Not-Started dates */
                                                        <Button
                                                            color="primary"
                                                            size="sm"
                                                            className="d-flex align-items-center gap-1 px-3 py-1 text-white border-0"
                                                            style={{
                                                                borderRadius: '6px',
                                                                fontSize: '0.85rem',
                                                                backgroundColor: '#0d6efd',
                                                            }}
                                                            onClick={() => {
                                                                setExpandedDateIndex(isExpanded ? null : idx);
                                                            }}
                                                        >
                                                            <span>Select</span>
                                                            <FeatherIconCom iconName={isExpanded ? "ChevronUp" : "ChevronDown"} size={14} />
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Expandable Punch In Action Panel (Only for NOT started dates) */}
                                            {isExpanded && isNotStarted && (
                                                <div className="bg-light p-3 rounded-3 mt-3 border">
                                                    <Row className="g-2 mb-3">
                                                        <Col xs={6}>
                                                            <label className="form-label small fw-semibold text-muted mb-1">Punch In Time</label>
                                                            <div className="bg-white rounded border d-flex align-items-center justify-content-between px-2 py-1 position-relative" style={{ height: '38px' }}>
                                                                <span className="fw-semibold text-dark ps-1" style={{ fontSize: '0.9rem' }}>
                                                                    {formatTime12h(selectedTime)}
                                                                </span>
                                                                <FeatherIconCom iconName="Clock" size={16} className="text-dark opacity-75 me-1" />
                                                                <Input
                                                                    type="time"
                                                                    value={selectedTime}
                                                                    onChange={(e) => setSelectedTime(e.target.value)}
                                                                    className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col xs={6}>
                                                            <label className="form-label small fw-semibold text-muted mb-1">Select Start Town</label>
                                                            <Select
                                                                options={townOptions}
                                                                value={townOptions.find((opt) => String(opt.value) === String(selectedStartTown)) || null}
                                                                onChange={(opt: any) => setSelectedStartTown(opt ? opt.value : "")}
                                                                isSearchable={true}
                                                                isLoading={loadingTowns}
                                                                placeholder={loadingTowns ? "Loading towns..." : "Select Start Town..."}
                                                                noOptionsMessage={() => "No towns available"}
                                                                menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                                                                menuPosition="fixed"
                                                                styles={townSelectStyles}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Button
                                                        color="success"
                                                        className="w-100 py-2 fw-bold border-0 text-white mb-2"
                                                        disabled={submittingPunchIn}
                                                        style={{
                                                            backgroundColor: '#6ec038',
                                                            fontSize: '1rem',
                                                            borderRadius: '8px',
                                                        }}
                                                        onClick={() => handlePunchIn(item.date || item.AttendanceDate)}
                                                    >
                                                        {submittingPunchIn ? <Spinner size="sm" color="light" /> : "Start your day"}
                                                    </Button>

                                                    <div className="text-muted text-center" style={{ fontSize: '0.78rem' }}>
                                                        You are going to start your day at{" "}
                                                        <strong className="text-primary">{getTownNameById(selectedStartTown) || "selected town"}</strong> at{" "}
                                                        <strong className="text-primary">{formatTime12h(selectedTime)}</strong>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-center text-muted py-4 small">
                                    No attendance days available
                                </div>
                            )}
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Dedicated Punch Out Modal */}
            <Modal
                isOpen={punchOutModalOpen}
                toggle={() => setPunchOutModalOpen(!punchOutModalOpen)}
                centered
                style={{ maxWidth: '440px' }}
                contentClassName="border-0 shadow-lg"
            >
                <div
                    className="modal-header d-flex justify-content-between align-items-center border-0 pb-0 pt-4 px-4"
                    style={{ borderRadius: '20px 20px 0 0' }}
                >
                    <h5 className="modal-title fw-bold text-dark" style={{ fontSize: '1.2rem' }}>
                        End Your Day (Punch Out)
                    </h5>
                    <button
                        type="button"
                        className="btn-close-custom d-flex align-items-center justify-content-center border-0 text-white"
                        onClick={() => setPunchOutModalOpen(false)}
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            backgroundColor: '#495057',
                            cursor: 'pointer',
                        }}
                    >
                        <FeatherIconCom iconName="X" size={18} className="text-white" />
                    </button>
                </div>

                <ModalBody className="px-4 pt-3 pb-4">
                    <Row className="g-2 mb-3">
                        <Col xs={6}>
                            <label className="form-label small fw-semibold text-muted mb-1">Punch Out Time</label>
                            <div className="bg-white rounded border d-flex align-items-center justify-content-between px-2 py-1 position-relative" style={{ height: '38px' }}>
                                <span className="fw-semibold text-dark ps-1" style={{ fontSize: '0.9rem' }}>
                                    {formatTime12h(selectedTime)}
                                </span>
                                <FeatherIconCom iconName="Clock" size={16} className="text-dark opacity-75 me-1" />
                                <Input
                                    type="time"
                                    value={selectedTime}
                                    onChange={(e) => setSelectedTime(e.target.value)}
                                    className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
                                />
                            </div>
                        </Col>
                        <Col xs={6}>
                            <label className="form-label small fw-semibold text-muted mb-1">Select End Town</label>
                            <Select
                                options={townOptions}
                                value={townOptions.find((opt) => String(opt.value) === String(selectedEndTown)) || null}
                                onChange={(opt: any) => setSelectedEndTown(opt ? opt.value : "")}
                                isSearchable={true}
                                isLoading={loadingTowns}
                                placeholder={loadingTowns ? "Loading towns..." : "Select End Town..."}
                                noOptionsMessage={() => "No towns available"}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                                menuPosition="fixed"
                                styles={townSelectStyles}
                            />
                        </Col>
                    </Row>

                    <Button
                        color="danger"
                        className="w-100 py-2 fw-bold border-0 text-white mb-2"
                        disabled={submittingPunchOut}
                        style={{
                            backgroundColor: '#dc3545',
                            fontSize: '1rem',
                            borderRadius: '8px',
                        }}
                        onClick={() => {
                            const targetDate = selectedDate || activePunchItem?.date || activePunchItem?.AttendanceDate || moment().format('YYYY-MM-DD');
                            handlePunchOut(targetDate);
                        }}
                    >
                        {submittingPunchOut ? <Spinner size="sm" color="light" /> : "End your day (Punch Out)"}
                    </Button>

                    <div className="text-muted text-center" style={{ fontSize: '0.78rem' }}>
                        You are going to end your day at{" "}
                        <strong className="text-primary">{getTownNameById(selectedEndTown) || "selected town"}</strong> at{" "}
                        <strong className="text-primary">{formatTime12h(selectedTime)}</strong>
                    </div>
                </ModalBody>
            </Modal>

            {/* Unlock Request Modal for Locked Dates */}
            <Modal
                isOpen={unlockModalOpen}
                toggle={() => !unlockLoading && setUnlockModalOpen(false)}
                centered
                style={{ maxWidth: '440px' }}
                contentClassName="border-0 shadow-lg"
            >
                <div className="modal-header d-flex justify-content-between align-items-center border-0 pb-0 pt-4 px-4">
                    <h5 className="modal-title fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '1.15rem' }}>
                        <FeatherIconCom iconName="Unlock" size={18} className="text-primary" />
                        <span>Unlock Date Request</span>
                    </h5>
                    <button
                        type="button"
                        className="btn-close-custom d-flex align-items-center justify-content-center border-0 text-white"
                        onClick={() => !unlockLoading && setUnlockModalOpen(false)}
                        style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            backgroundColor: '#333',
                            lineHeight: 1,
                            cursor: 'pointer',
                        }}
                    >
                        ✕
                    </button>
                </div>
                <ModalBody className="px-4 pt-3 pb-4">
                    {selectedLockedItem && (() => {
                        const rawD = selectedLockedItem.date || selectedLockedItem.AttendanceDate;
                        const targetD = moment(rawD, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-MM-DD HH:mm:ss']).format('YYYY-MM-DD');
                        const detail = unlockRequestsMap[targetD];
                        const status = detail?.status || selectedLockedItem?.AttendanceRequestStatus || selectedLockedItem?.RequestStatus;
                        const sentAt = detail?.sentAt;
                        const existingRemark = detail?.remark;
                        const lockReason = selectedLockedItem.Lockedreason || selectedLockedItem.Note || 'Account locked for this date';

                        if (loadingAttendanceDetail) {
                            return (
                                <div className="text-center py-4">
                                    <Spinner size="sm" color="primary" />
                                    <div className="text-muted mt-2 small">Loading request details...</div>
                                </div>
                            );
                        }

                        if (status === 'Requested') {
                            return (
                                <div>
                                    <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: '0.85rem' }}>
                                        <div className="fw-semibold">Request Pending Approval</div>
                                        <div>
                                            Your unlocking request was sent on{' '}
                                            <strong>
                                                {sentAt ? moment(sentAt).format('DD MMM, hh:mm A') : 'recently'}
                                            </strong> for date <strong>{moment(targetD).format('DD MMM YYYY')}</strong>.
                                        </div>
                                    </div>
                                    {existingRemark && (
                                        <div className="bg-light p-2 rounded mb-3" style={{ fontSize: '0.85rem' }}>
                                            <span className="text-muted">Remark: </span>
                                            <span className="fw-semibold text-dark">{existingRemark}</span>
                                        </div>
                                    )}
                                    <Button
                                        color="secondary"
                                        outline
                                        className="w-100 py-2"
                                        style={{ borderRadius: '6px' }}
                                        onClick={() => setUnlockModalOpen(false)}
                                    >
                                        Close
                                    </Button>
                                </div>
                            );
                        }

                        if (status === 'Rejected') {
                            return (
                                <div>
                                    <div className="alert alert-danger py-2 px-3 mb-3" style={{ fontSize: '0.85rem' }}>
                                        <div className="fw-semibold">Request Rejected</div>
                                        <div>
                                            Your unlocking request for <strong>{moment(targetD).format('DD MMM YYYY')}</strong> was rejected.
                                        </div>
                                        {existingRemark && (
                                            <div className="mt-1">
                                                Manager Remark: <em>"{existingRemark}"</em>
                                            </div>
                                        )}
                                    </div>

                                    <FormGroup className="mb-3">
                                        <Label className="small fw-semibold text-muted mb-1">
                                            New Unlocking Remark <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                            type="textarea"
                                            rows={3}
                                            placeholder="Enter reason for re-requesting unlock..."
                                            value={unlockRemark}
                                            onChange={(e) => setUnlockRemark(e.target.value)}
                                            disabled={unlockLoading}
                                        />
                                    </FormGroup>

                                    <div className="d-flex gap-2">
                                        <Button
                                            color="secondary"
                                            outline
                                            className="flex-fill"
                                            onClick={() => setUnlockModalOpen(false)}
                                            disabled={unlockLoading}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            color="primary"
                                            className="flex-fill d-flex align-items-center justify-content-center gap-1"
                                            onClick={handleSendUnlockRequest}
                                            disabled={unlockLoading}
                                        >
                                            {unlockLoading ? <Spinner size="sm" /> : <FeatherIconCom iconName="Send" size={14} />}
                                            <span>Re-send Request</span>
                                        </Button>
                                    </div>
                                </div>
                            );
                        }

                        return (
                            <div>
                                <div className="bg-light p-3 rounded mb-3" style={{ fontSize: '0.875rem' }}>
                                    <div className="mb-1">
                                        <span className="text-muted">Locked Date: </span>
                                        <span className="fw-semibold text-dark">{moment(targetD).format('DD MMM YYYY')}</span>
                                    </div>
                                    <div>
                                        <span className="text-muted">Reason: </span>
                                        <span className="fw-semibold text-danger">{lockReason}</span>
                                    </div>
                                </div>

                                <FormGroup className="mb-3">
                                    <Label className="small fw-semibold text-muted mb-1">
                                        Unlocking Remark <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                        type="textarea"
                                        rows={3}
                                        placeholder="Enter unlocking remark..."
                                        value={unlockRemark}
                                        onChange={(e) => setUnlockRemark(e.target.value)}
                                        disabled={unlockLoading}
                                    />
                                </FormGroup>

                                <div className="d-flex gap-2">
                                    <Button
                                        color="secondary"
                                        outline
                                        className="flex-fill"
                                        onClick={() => setUnlockModalOpen(false)}
                                        disabled={unlockLoading}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        color="primary"
                                        className="flex-fill d-flex align-items-center justify-content-center gap-1"
                                        onClick={handleSendUnlockRequest}
                                        disabled={unlockLoading}
                                    >
                                        {unlockLoading ? <Spinner size="sm" /> : <FeatherIconCom iconName="Send" size={14} />}
                                        <span>Send Request</span>
                                    </Button>
                                </div>
                            </div>
                        );
                    })()}
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
